import { Tooltip } from '../ui/modal'
import { TooltipProps } from '../ui/modal/Tooltip'

interface HintTooltipProps extends Omit<TooltipProps, 'content'> {
  trigger: React.ReactNode;
  text: React.ReactNode;
  enabled?: boolean;
}

/** 提示 tooltip */
export const HintTooltip: React.FC<HintTooltipProps> = ({
  trigger, text, enabled = true, ...props }) => {
  return (
    <Tooltip
      side='top'
      align='center'
      {...props}
      trigger={trigger}
      content={
        enabled ? (
          <div className='relative bg-[rgba(16,24,40,1)] px-3 py-2 rounded-[8px]'>
            <span className='text-[rgba(255,255,255,1)] text-sm font-medium'>
              {text}
            </span>
            <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-black"></div>
          </div>
        ) : null
      }
    />
  )
}